const DefaultBadge = ({ status, background = "", customCases = {}, custom }) => {
  let name;
  let bg;
  let text;
  let border;

  name = customCases[status] || ""; // Use custom label if provided

  switch (status) {
    case 0:
      name = name || "Pending";
      bg = "bg-warning-50";
      text = "text-warning-700";
      border = "border-warning-300";
      break;
    case 1:
      name = name || "Approved";
      bg = "bg-success-50";
      text = "text-success-700";
      border = "border-success-300";
      break;
    case 2:
      name = name || "Rejected";
      bg = "bg-error-50";
      text = "text-error-700";
      border = "border-error-300";
      break;
    default:
      name = name || "Pending";
      bg = background || "bg-warning-50";
      text = "text-warning-700";
      border = "border-warning-300";
      break;
  }

  return custom ? (
    <span
      className={`flex justify-self-start max-w-fit min-w-32 items-center font-medium px-1 text-xs rounded-md
     ${bg ? bg : "bg-light"} ${text ? text : "text-primary-700"} ${
        border ? `border ${border}` : "border-primary-700"
      }`}
    >
      {custom}
    </span>
  ) : (
    <span
      className={`flex justify-self-start max-w-fit items-center font-medium px-1 text-xs rounded-md
       ${bg ? bg : "bg-light"} ${text ? text : "text-primary-700"} ${
        border ? `border ${border}` : "border-primary-700"
      }`}
    >
      {name}
    </span>
  );
};

export default DefaultBadge;
